import { Link } from "react-router-dom";
import { BRAND } from "../config/brand";

export const Footer = () => (
  <footer className="border-t border-ivory/10 bg-plum" data-testid="footer">
    <div className="mx-auto flex max-w-[1280px] flex-col gap-8 px-5 py-14 sm:px-8 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="flex items-center gap-2.5">
          <img src="/assets/logo-mark.png" alt="" className="h-9 w-auto" width={28} height={37} loading="lazy" />
          <span className="font-serif text-3xl font-semibold tracking-tight text-ivory">
            {BRAND.name}
          </span>
        </p>
        <p className="mt-2 font-serif text-lg italic text-blush">{BRAND.tagline}</p>
      </div>
      <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-8 gap-y-3">
        <button
          type="button"
          data-testid="footer-clear-head-kit"
          onClick={() => window.dispatchEvent(new Event("bp-open-clearhead"))}
          className="text-xs font-bold uppercase tracking-[0.18em] text-blush transition-colors hover:text-ivory"
        >
          Free Clear Head Kit
        </button>
        {[
          { label: "Privacy", to: "/privacy" },
          { label: "Terms", to: "/terms" },
          { label: "Refunds", to: "/refunds" },
          { label: "Delivery", to: "/shipping" },
          { label: "Contact", to: "/contact" },
        ].map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`footer-link-${l.label.toLowerCase()}`}
            className="text-xs font-bold uppercase tracking-[0.18em] text-ivory/60 transition-colors hover:text-ivory"
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </div>
    <div className="border-t border-ivory/10">
      <p className="mx-auto max-w-[1280px] px-5 py-5 text-xs text-ivory/40 sm:px-8">
        © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
      </p>
    </div>
  </footer>
);
